// API helper for authenticated fetch requests to Rails JSON endpoints
export async function apiRequest(
  url: string,
  options: RequestInit = {}
): Promise<Response> {
  const csrfToken =
    document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content") || "";

  const defaultHeaders: Record<string, string> = {
    "X-CSRF-Token": csrfToken,
    Accept: "application/json",
  };

  // Only set Content-Type for non-FormData bodies
  if (!(options.body instanceof FormData)) {
    defaultHeaders["Content-Type"] = "application/json";
  }

  return fetch(url, {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
    credentials: "same-origin",
  });
}

export async function apiGet(url: string) {
  return apiRequest(url, { method: "GET" });
}

export async function apiPost(url: string, data: unknown) {
  return apiRequest(url, {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export async function apiPatch(url: string, data: unknown) {
  return apiRequest(url, {
    method: "PATCH",
    body: JSON.stringify(data),
  });
}

export async function apiDelete(url: string) {
  return apiRequest(url, { method: "DELETE" });
}
